import { EpimsBaseEntityDto } from './epim-base.dto';
export class PaymentStatusDto extends EpimsBaseEntityDto {

    PaymentStatusId: string;

    PaymentStatusName: string;   

}